import React from "react";
import PricingSectionPending from "./pricing/PricingSectionPending";
import PricingSectionRejected from "./pricing/PricingSectionRejected";
import PricingSectionQuoteReady from "./pricing/PricingSectionQuoteReady";
import PricingSectionAwaitingApproval from "./pricing/PricingSectionAwaitingApproval";
import PricingSectionToBeReimbursed from "./pricing/PricingSectionToBeReimbursed";
import PricingSectionReimbursed from "./pricing/PricingSectionReimbursed";

function RefundConfimationPricingSection({ data }) {
  switch (data?.status) {
    case "Denied":
    case "Cancelled":
    case "Canceled":
      return <PricingSectionRejected data={data} />;
    case "Approved":
      if (data?.confirmed) {
        return <PricingSectionAwaitingApproval data={data} />;
      } else if (data?.isQuoted || data?.priceReceived) {
        return <PricingSectionQuoteReady data={data} />;
      } else {
        return <PricingSectionPending data={data} />;
      }
    case "PendingRefund":
      return <PricingSectionToBeReimbursed data={data} />;
    case "Success":
      return <PricingSectionReimbursed data={data} />;
    case "Pending":
    default:
      return <PricingSectionPending data={data} />;
  }
}

export default RefundConfimationPricingSection;
